<template>
  <main :class="style.doctorAppointment">
    <h2>
      Мы получили вашу заявку, администратор свяжется с вами для подтверждения
      записи
    </h2>
    <div :class="style.infoAppointment">
      <section>
        <span
          v-text="
            chose?.doctor?.specialization && chose?.doctor?.specialization[0]
              ? chose.doctor.specialization.join(', ')
              : 'Специализация врача'
          "
        />
        <div v-text="chose.DoctorName" />
      </section>
      <section>
        <span>Адрес</span>
        <div
          v-show="bool"
          v-for="(bool, address) in chose.doctor?.address"
          v-text="address"
        />
      </section>
      <section>
        <span>Услуга</span>
        <div v-text="chose.DoctorService" />
      </section>
      <section>
        <span>Дата и время</span>
        <div v-text="chose.PlanStart" />
      </section>
    </div>
    <span :class="style.caution">
      Приходите за 15 минут, чтобы<br />
      успеть провести оформление.<br />
      Возьмите с собой пасспорт,<br />
      результаты и снимки предыдущих<br />
      обследований.
    </span>
  </main>
</template>
<script lang="ts">
import {defineComponent} from "vue";
import style from "../StyleWidget.module.scss";
export default defineComponent({
  name: "AppointmentSuccess",
  data() {
    return {
      style
    };
  },
  computed: {
    chose() {
      return this.$widgetStore.getChose;
    }
  }
});
</script>
